import { Link } from "react-router-dom";
import { useApi } from "../app/ApiContext";
import { LEAGUE_ID } from "../app/config";
import { usePremFixtures, useSettings, useStandings } from "../data";
import { PremFixtureRow } from "./PremFixtureRow";
import "./MatchupsAside.css";

/** Desktop side column: Premier League games in play and the top of the table. */
export const MatchupsAside = () => {
	const api = useApi();
	const { fixtures } = usePremFixtures(api);
	const { standings } = useStandings(api, LEAGUE_ID);
	const { myEntryId } = useSettings();

	const live = fixtures.filter((f) => f.live);
	const shown = live.length > 0 ? live.slice(0, 3) : fixtures.filter((f) => !f.finished).slice(0, 3);
	const label = live.length > 0 ? "Premier League · Live" : "Premier League · Up next";

	return (
		<aside className="matchups-aside" aria-label="Around the league">
			{shown.length > 0 && (
				<section className="aside-section">
					<div className="eyebrow aside-heading">{label}</div>
					<div className="aside-list">
						{shown.map((f, i) => (
							<PremFixtureRow key={`${f.homeTeam}-${i}`} fixture={f} />
						))}
					</div>
					<Link to="/fixtures" className="aside-more mono">
						All fixtures →
					</Link>
				</section>
			)}

			{standings.length > 0 && (
				<section className="aside-section">
					<div className="eyebrow aside-heading">Standings · Top 4</div>
					<div className="card aside-table">
						{standings.slice(0, 4).map((t) => (
							<div key={t.entry} className={`aside-row${t.entry === myEntryId ? " your-row" : ""}`}>
								<div className="aside-rank mono">{t.rank}</div>
								<div>
									<div className="aside-team">{t.entry_name}</div>
									<div className="aside-manager">{t.player_name}</div>
								</div>
								<div className="aside-points mono">{t.total}</div>
							</div>
						))}
					</div>
					<Link to="/table" className="aside-more mono">
						Full table →
					</Link>
				</section>
			)}
		</aside>
	);
};
